import React, { Fragment } from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Chip } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { BaseEntityPage } from '../../common/components/BaseEntityPage';
import { Helper } from '../../common/helpers/Helper';
import { AppHelper } from '../../helpers/AppHelper';
import { AppUiHelper } from '../../helpers/AppUiHelper';
import { VenueSummary } from '../../components/VenueSummary';
import { Stats } from '../../components/Stats';

export class EventDetailsPartner extends BaseEntityPage {

  constructor(props) {
    super(props, { pageForOrgType: 'PARTNER' });
    this.pageKey = 'Event';
    this.pageTitle = 'Event Details';
    this.noAdd = true;
    this.orgType = 'PARTNER';
    this.orgId = this.props.match.params.orgId;
    this.eventId = this.props.match.params.eventId;
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: 'Events', to: `${this.baseRoute()}/events` },
      { title: this.pageTitle },
    ];
    this.cellWidths = {
      Venue: Styles.venueCell,
      Info: Styles.infoCell,
      Status: Styles.statusCell,
      actions: Styles.actionsCell
    }
    this.tableHeadersMap = {
      Index: (current) => { return <span className={css(Styles.value)}>{current.__index + 1}</span> },
      Venue: (current) => {
        return (
          <div className={css(Styles.venueColumn)}>
            <VenueSummary
              item={current}
            />
          </div>
        )
      },
      // Info: (current) => {
      //   return (
      //     <div className={css(Styles.infoColumn)}>
      //       <div className={css(Styles.sideBySideInfo)}>
      //         <div>
      //           <div className={css(Styles.infoTextHolder)}>
      //             {current.latestDeviceFeed && current.latestDeviceFeed.currentTs &&
      //               <span className={css(Styles.value, Styles.line2)}>
      //                 {AppHelper.formatActiveTime(Helper.currentTs() - current.latestDeviceFeed.currentTs)}
      //               </span>
      //             }
      //             {!current.latestDeviceFeed &&
      //               <span className={css(Styles.value, Styles.line2)}>
      //                 {`Active : ${Helper.getString('unknown')}`}
      //               </span>
      //             }
      //           </div>
      //           {!AppHelper.isNonApkDevice(current) &&
      //             <div className={css(Styles.infoTextHolder)}>
      //               {current.latestDeviceFeed && current.latestDeviceFeed.versionCode &&
      //                 <span className={css(Styles.value, Styles.line2)}>
      //                   {`App : #${current.latestDeviceFeed.versionCode}`}
      //                 </span>
      //               }
      //               {!current.latestDeviceFeed &&
      //                 <span className={css(Styles.value, Styles.line2)}>
      //                   {`App : ${Helper.getString('unknown')}`}
      //                 </span>
      //               }
      //             </div>
      //           }
      //           <div className={css(Styles.infoTextHolder)}>
      //             <span className={css(Styles.value, Styles.line2)}>
      //               {`Audio Ads: ${current.audioAdPartnerIds && current.audioAdPartnerIds.length || 0}`}
      //             </span>
      //           </div>
      //           <div className={css(Styles.infoTextHolder)}>
      //             <span className={css(Styles.value, Styles.line2)}>
      //               {`Tags : ${current.tagsPartner && current.tagsPartner.length || 0}`}
      //             </span>
      //           </div>
      //           <div className={css(Styles.infoTextHolder)}>
      //             <span className={css(Styles.value, Styles.line2)}>
      //               {`Orientation : ${current._ORIENTATION || 'UNKNOWN'}`}
      //             </span>
      //           </div>
      //           <div className={css(Styles.infoTextHolder)}>
      //             <span className={css(Styles.value, Styles.line2)}>
      //               {`Disp Campaigns : ${current.campaignsPartner && current.campaignsPartner.length || 0}`}
      //             </span>
      //           </div>
      //           <div className={css(Styles.infoTextHolder)}>
      //             <span className={css(Styles.value, Styles.line2)}>
      //               {`Disp Ads : ${current.imageAdPartnerIds && current.imageAdPartnerIds.length || 0}`}
      //             </span>
      //           </div>
      //         </div>
      //       </div>
      //       <div>
      //         {current.tagsPartner &&
      //           <div className={css(Styles.tagHolder)}>
      //             {AppHelper.getTagChips(current.tagsPartner, this.state.tags).map((x, i) =>
      //               <Chip key={'chip_' + i} label={x} size='small' className={css(Styles.tagChip)} />
      //             )}
      //           </div>
      //         }
      //       </div>
      //     </div>
      //   )
      // },
      Status: (current) => {
        return (
          <Fragment>
            <div className={css(Styles.statusHolder)}>
              <div className={css(Styles.displayInRow)}>
                <span>
                  {
                    (current.latestDeviceFeed && current.latestDeviceFeed.currentTs)
                      ? AppHelper.getVenueStatus(Helper.currentTs() - current.latestDeviceFeed.currentTs)
                      : AppHelper.offlineStatus()
                  }
                </span>
              </div>
            </div>
          </Fragment>
        )
      }
    };
    this.tableHeaders = Object.keys(this.tableHeadersMap);
    this.noTableHead = true;
    this.emptyText = 'No event found';
    this.toFetch = [
      { method: 'GET', paths: ['miscs', 'events'], queryParams: { eventId: this.eventId } },
      { method: 'GET', paths: ['devicetags'], queryParams: { groupId: this.orgId, pb: 'fieldDef' } },
    ];
  }

  onFetchSuccess(results) {
    const response = results[0] || {}
    const item = response.item || response.event || response
    const devices = item && Array.isArray(item.devices) ? item.devices : []
    const processedDevices = AppHelper.processVenueItems(devices)
    this.pageTitle = this.getDetailTitle(item)
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: this.baseRoute({ home: true }) },
      { title: 'Events', to: `${this.baseRoute()}/events` },
      { title: this.pageTitle },
    ]
    this.setState({
      items: processedDevices || [],
      eventItem: item || null,
      tags: results[1] || { items: [] },
    });
  }

  getDetailTitle(item) {
    if (item && item.eventType === 'CONNECTIVITYALERT') {
      return 'Connectivity Alert'
    }
    return 'Event Details'
  }


  buildStatsItems() {
    const eventItem = this.state.eventItem || {}
    const eventTs = Helper.formatDateWithTimezoneSuffix({ utcTimestamp: eventItem.createdTs })
    const reportImages = AppUiHelper.getReportsStatsImages()
    const wrapValue = (value) => <span className={css(Styles.eventStatsValueWrap)}>{value}</span>
    return [
      {
        title: 'Event Type',
        value: wrapValue(AppHelper.getAlertTitle(eventItem.eventType)),
        image: reportImages.campaigns
      },
      {
        title: 'Event Time',
        value: wrapValue(eventTs),
        image: reportImages.impressions
      },
      {
        title: 'Device Count',
        value: wrapValue(Array.isArray(this.state.items) ? this.state.items.length : 0),
        image: reportImages.screens
      }
    ]
  }

  renderAboveTable() {
    if (!this.state.eventItem) return ''
    return (
      <div className={css(Styles.statsHolder)}>
        <Stats items={this.buildStatsItems()} statsBody={Styles.eventStatsBody} />
      </div>
    )
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) return ''
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onActions() {
    return []
  }
}

const Styles = StyleSheet.create({
  value: {
    fontSize: 12,
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  infoColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  },
  venueColumn: {
    minWidth: 260
  },
  sideBySideInfo: {
    display: 'flex',
    gap: 24,
    flexWrap: 'wrap'
  },
  infoTextHolder: {
    marginBottom: 2
  },
  line2: {
    fontSize: 12
  },
  venueCell: {
    width: '34%'
  },
  infoCell: {
    width: '42%'
  },
  statusCell: {
    width: '16%'
  },
  actionsCell: {
    width: '8%'
  },
  statusHolder: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  displayInRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8
  },
  statsHolder: {
    width: '100%',
    marginBottom: 16
  },
  eventStatsBody: {
    minWidth: '200px !important',
    padding: '16px 18px !important'
  },
  eventStatsValueWrap: {
    fontSize: 20,
  },
  tagHolder: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 6,
    marginTop: 6
  },
  tagChip: {
    backgroundColor: '#EFEFEF'
  }
});



// WEBPACK FOOTER //
// ./src/screens/admin/EventDetailsPartner.js